import app from 'flarum/forum/app';
export function loadRecitals() {
  if (!app.forum || !app.forum.attribute('canPublishRecital')) {
    return Promise.resolve([]);
  }
  if (!app.store || !app.store.find) {
    return Promise.resolve([]);
  }
  return app.store.find('recitals');
}
export function getRecitalForDiscussion(discussion) {
  if (!discussion || !discussion.id) return null;
  var discussionId = discussion.id();
  if (discussionId === null || discussionId === undefined) return null;
  var recitals = app.store && app.store.all ? app.store.all('recitals') : [];
  var id = String(discussionId);
  for (var i = 0; i < recitals.length; i++) {
    var recital = recitals[i];
    if (!recital) continue;
    var submissionDiscussionId = recital.submissionDiscussionId ? recital.submissionDiscussionId() : null;
    var announcementDiscussionId = recital.announcementDiscussionId ? recital.announcementDiscussionId() : null;
    if (submissionDiscussionId !== null && submissionDiscussionId !== undefined && String(submissionDiscussionId) === id) {
      return recital;
    }
    if (announcementDiscussionId !== null && announcementDiscussionId !== undefined && String(announcementDiscussionId) === id) {
      return recital;
    }
  }
  return null;
}